module.exports = __webpack_public_path__ + "img/IMG_20180706_125630.9cd6f815.jpg";